define("StoreLocator.Results.View.Extension", [
    "StoreLocator.Results.View",
    "underscore",
    "Ames.StoreLocator2.StoreLocator2.Model",
  ], function (StoreLocatorResultsView, _, StoreLocator2Model) {
    _.extend(StoreLocatorResultsView.prototype, {
      initialize: _.wrap(
        StoreLocatorResultsView.prototype.initialize,
        function (fn) {
          // keep original init
          fn.apply(this, Array.prototype.slice.call(arguments, 1));
  
          this.locatorModel = new StoreLocator2Model();
          var self = this;
          this.optionsSelected = null;
  
          this.collection.on("reset sync", function () {
            self.locatorModel
              .fetch({ data: { locationId: "all" } })
              .done(function (resp) {
                var raw = localStorage.getItem("locationSelected");
                // check if store-locator-search-button-find  is on the template

                
  
                if (!raw && jQuery(".store-locator-search-button-find").length === 0) {
                  var saturdayFilter = localStorage.getItem("filterOpenSaturday") == "true";
                  console.log('saturdayFilter', saturdayFilter);

                  if (saturdayFilter) {
                    var originals = self.collection.models.slice();
                    var matched = [];
                    var locations = resp.locations || [];
                    originals.forEach(function (model) {
                      var loc = _.findWhere(locations, { id: model.id });
                      if (!loc) return;
                      if (loc.openSaturday == true) {
                        matched.push(model);
                      }
                    })
                    // limit to first 3 and update collection
                    var toShow = matched.slice(0, 3);
                    self.collection.models = toShow;
                    self.collection.length = toShow.length;
                    self.render();
                  } else {
                    // get the first 3 locations
                    self.collection.models = self.collection.models.slice(0, 3);
                    self.collection.length = 3;
                    self.render();
                  }
                  return;
                }
                if (!raw) {
                  console.log('no options selected');
                  return;
                }
                self.optionsSelected = JSON.parse(raw);
  
                // static copy of original models
                var originals = self.collection.models.slice();
                var matched = [];
                var locations = resp.locations || [];

                var saturdayFilter = localStorage.getItem("filterOpenSaturday") == "true";
                console.log('saturdayFilter', saturdayFilter);
                // filter by shopType or extraTypes
                originals.forEach(function (model) {
                  var loc = _.findWhere(locations, { id: model.id });
                  if (!loc) return;
                  var shopOK = self.optionsSelected.indexOf(loc.shopType) !== -1;
                  // var extras = loc.extraTypes ? loc.extraTypes.split(',') : [];
                  // trim and split extraTypes string into array
                  var extras = loc.extraTypes
                    ? loc.extraTypes.split(",").map(function (t) {
                        return t.trim();
                      })
                    : [];
                  // check if any extra type is selected
                  var extraOK = extras.some(function (type) {
                    return self.optionsSelected.indexOf(parseFloat(type)) != -1;
                  });
                  if (shopOK || extraOK) {
                    if (saturdayFilter) {
                      if (loc.openSaturday == true) {
                        matched.push(model);
                      }
                    } else {
                      matched.push(model);
                    }
                  }
                });
  
                // limit to first 3 and update collection
                var toShow = matched.slice(0, 3);
                if (toShow.length === 0 && self.optionsSelected.length > 0) {
                  setTimeout(function () {
                    $(".store-locator-results-list").hide();
                    $(".store-locator-results-nav-description-highlight").text(
                      "No results found"
                    );
                  }, 1000);
                } else if (toShow.length === 0 && originals.length > 0) {
                  self.collection.models = originals.slice(0, 3);
                  self.collection.length = 3;
                } 
                else {
                  self.collection.models = toShow;
                  self.collection.length = toShow.length;
                }
  
                self.render();
              });
          });
          self.locatorModel
              .fetch({ data: { locationId: "all" } })
              .done(function (resp) {
                var raw = localStorage.getItem("locationSelected");
                if (!raw) {
                  console.log('no options selected');
                  return;
                }
                self.optionsSelected = JSON.parse(raw);
  
                // static copy of original models
                var originals = self.collection.models.slice();
                var matched = [];
                var locations = resp.locations || [];

                var saturdayFilter = localStorage.getItem("filterOpenSaturday") == "true";
                console.log('saturdayFilter', saturdayFilter);
  
                // filter by shopType or extraTypes
                originals.forEach(function (model) {
                  var loc = _.findWhere(locations, { id: model.id });
                  if (!loc) return;
                  var shopOK = self.optionsSelected.indexOf(loc.shopType) !== -1;
                  // var extras = loc.extraTypes ? loc.extraTypes.split(',') : [];
                  // trim and split extraTypes string into array
                  var extras = loc.extraTypes
                    ? loc.extraTypes.split(",").map(function (t) {
                        return t.trim();
                      })
                    : [];
                  // check if any extra type is selected
                  var extraOK = extras.some(function (type) {
                    return self.optionsSelected.indexOf(parseFloat(type)) != -1;
                  });
                  if (shopOK || extraOK) {
                    if (saturdayFilter) {
                      if (loc.openSaturday == true) {
                        matched.push(model);
                      }
                    } else {
                      matched.push(model);
                    }
                  }
                });
  
                // limit to first 3 and update collection
                var toShow = matched.slice(0, 3);
                if (toShow.length === 0 && self.optionsSelected.length > 0) {
                  setTimeout(function () {
                    $(".store-locator-results-list").hide();
                    $(".store-locator-results-nav-description-highlight").text(
                      "No results found"
                    );
                  }, 1000);
                } else if (toShow.length === 0 && originals.length > 0) {
                  self.collection.models = originals.slice(0, 3);
                  self.collection.length = 3;
                } 
                else {
                  self.collection.models = toShow;
                  self.collection.length = toShow.length;
                }
  
                self.render();
              });
        }
      ),
  
      getContext: _.wrap(
        StoreLocatorResultsView.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, Array.prototype.slice.call(arguments, 1));
          var optionsSelected = localStorage.getItem("locationSelected");
          var optionLabels = [
            'Decorative Finish',
            'EIFS',
            'Masonry'
          ]
          var optionSelection = '';
          if (!optionsSelected) {
            // no options selected
            context.selectedOptions = '';
          } else {
            // parse the selected options
            var selectedOptions = JSON.parse(optionsSelected);
            // check if the location is already selected
            if (selectedOptions.length > 0) {
              _.each(selectedOptions, function (locIndex) {
                if (!optionSelection) {
                  optionSelection = optionLabels[locIndex - 1];
                } else {
                  optionSelection = optionSelection + ', ' + optionLabels[locIndex - 1];
                }
              })
              context.selectedOptions = optionSelection;
            } else {
              context.selectedOptions = '';
            }
          }
          // check if there are already selected options
          return context
          
        }
      ),
    });
  });
  
